import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'beforeYet'
})
export class BeforeYetPipe implements PipeTransform {

  transform(value: string): boolean {
    if(!value) return false;
    return moment(value).isBefore(moment());
  }

}
